import React from 'react'
import { map } from 'lodash'

import SEO from 'components/SEO'
import LayoutSEM from 'components/SEM/LayoutSEM'
import HeroTwo from 'components/SEM/HeroTwo'
import TwoColumn from 'components/SEM/TwoColumn'
import FullWidthImage from 'components/projects/shared/FullWidthImage'
import FeaturedProjects from 'components/SEM/FeaturedProjects'
import InlineButtonHeader from 'components/SEM/InlineButtonHeader'
import TestimonialSlider from 'components/TestimonialSlider'

import { THEME_WHITE } from 'theme/constants'
import { seoPageData } from 'data/services/front-end-development-company'
import {
  HERO_TWO,
  TWO_COLUMN,
  FEATURED_PROJECTS,
  FULL_WIDTH_IMAGE,
  INLINE_BUTTON_HEADER,
} from 'components/SEM/constants'

const SEOTemplatePage = () => {
  const { theme, layout } = seoPageData

  /* eslint-disable react/jsx-props-no-spreading */
  function renderSection(section, index) {
    const { type } = section
    // Each component has an example it's required props in the constants file for that component
    switch (type) {
      case HERO_TWO:
        return <HeroTwo key={`${type}_${index}`} {...section} />
      case TWO_COLUMN:
        return <TwoColumn key={`${type}_${index}`} {...section} />
      case INLINE_BUTTON_HEADER:
        return <InlineButtonHeader key={`${type}_${index}`} {...section} />
      case FEATURED_PROJECTS:
        return <FeaturedProjects key={`${type}_${index}`} {...section} />
      case FULL_WIDTH_IMAGE:
        return <FullWidthImage key={`${type}_${index}`} {...section} />
      default:
        return null
    }
  }
  /* eslint-enable react/jsx-props-no-spreading */

  return (
    <LayoutSEM theme={theme}>
      <SEO
        title="Front End Development Company | Build With Studio"
        description="Learn about Studio’s frontend development services for prioritizing user engagement, branding, accessibility, and cross-platform compatibility."
      >
        <link
          rel="canonical"
          href="https://buildwithstudio.com/services/front-end-development-company/"
        />
      </SEO>
      {map(layout, (section, index) => renderSection(section, index))}
      <section className="services__section --no-padding --white">
        <TestimonialSlider
          theme={THEME_WHITE}
          offsetBefore={110}
          offsetBeforeMobile={25}
        />
      </section>
    </LayoutSEM>
  )
}

export default SEOTemplatePage
